import React from 'react'
import editIcon from '../assets/images/icons/edit.png'

const EditButton = ({ onClick }) => {
  return (
    <button
      className="vehicle-detail-button"
      style={{
        border: '1.5px solid #0A303B',
        background: '#f5f5f5',
        borderRadius: 6,
        height: 28,
        padding: '3.5px 9px 6px 10px',
        cursor: 'pointer',
        fontWeight: 700,
        boxShadow: '0 1px 8px rgba(0,0,0,0.30)',
        transition: 'transform 0.05s ease, box-shadow 0.1s ease',
        outline: 'none'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = '#2da9a4'
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = '#f5f5f5'
        e.currentTarget.style.transform = 'scale(1)'
        e.currentTarget.style.boxShadow = '0 1px 8px rgba(0,0,0,0.30)'
      }}
      onMouseDown={(e) => {
        e.currentTarget.style.transform = 'scale(0.96)'
        e.currentTarget.style.boxShadow = '0 0px 4px rgba(0,0,0,0.25)'
      }}
      onMouseUp={(e) => {
        e.currentTarget.style.transform = 'scale(1)'
        e.currentTarget.style.boxShadow = '0 1px 8px rgba(0,0,0,0.30)'
        e.currentTarget.blur()
      }}
      onClick={onClick}
    >
      <img
        src={editIcon}
        alt="edit"
        style={{
          width: 19,
          height: 19,
          display: 'block'
        }}
      />
    </button>
  )
}

export default EditButton